import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import ChangePassword from '../user/password/ChangePassword';
import ProfilePhoto from '../userProfile/ProfilePhoto';
import { observer } from 'mobx-react-lite';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
  cssClass: any;
  isMobile: boolean;
}

interface IProps {
  setActiveTab: (activeIndex: number) => void;
  isMobile: boolean;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, cssClass, isMobile, ...other } = props;

  return (
    <Box component='div'
      role="tabpanel"
      className={cssClass}
      hidden={value !== index}
      id={isMobile ? `vertical-tabpanel-${index}` : `horizontal-tabpanel-${index}`}
      aria-labelledby={isMobile ? `vertical-tab-${index}` : `horizontal-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </Box >
  );
}

function a11yProps(index: any, isMobile: boolean) {
  const tabId = isMobile ? `vertical-tab-${index}` : `horizontal-tab-${index}`;
  const tabPanel = isMobile ? `vertical-tabpanel-${index}` : `horizontal-tabpanel-${index}`;
  return {
    id: tabId,
    'aria-controls': tabPanel,
  };
}

const styles = {
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: 'flex',
    height: 'auto',
    minHeight: '100vh',
    paddingTop: 1,
  } as const,
  rootHorizontal: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    paddingTop: 10
  } as const,
  tabs: {
    minWidth: 180
  } as const,
  panel: {
    flexGrow: 1,
    minHeight: '100vh'
  } as const,
  tabsHorizontal: {
    width: '100%',
    maxHeight: 100,
    display: 'flex'
  } as const,
  panelHorizontal: {
    flexGrow: 1,
    minHeight: '100vh',
    width: '100%',
  } as const,
};

const UserProfileTabs: React.FC<IProps> = ({ setActiveTab, isMobile }) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setActiveTab(newValue);
  };

  return (
    <Box component={'div'} sx={isMobile ? styles.root : styles.rootHorizontal}>
      <Tabs
        orientation={!isMobile ? "horizontal" : "vertical"}
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="User profile tabs"
        sx={isMobile ? styles.tabs : styles.tabsHorizontal}
      >
        <Tab label="Change Password" {...a11yProps(0, isMobile)} />
        <Tab label="Photo" {...a11yProps(1, isMobile)} />
      </Tabs>
      <TabPanel cssClass={isMobile ? styles.panel : styles.panelHorizontal} value={value} index={0} isMobile>
        <ChangePassword />
      </TabPanel>
      <TabPanel cssClass={isMobile ? styles.panel : styles.panelHorizontal} value={value} index={1} isMobile>
        <ProfilePhoto />
      </TabPanel>
    </Box>
  );
}
export default observer(UserProfileTabs);
